import { render } from "./NoDataComponent.vue?vue&type=template&id=097d7f66&scoped=true"
import script from "./NoDataComponent.vue?vue&type=script&lang=js"
export * from "./NoDataComponent.vue?vue&type=script&lang=js"

import "./NoDataComponent.vue?vue&type=style&index=0&id=097d7f66&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097d7f66"]])

export default __exports__